import styled from "styled-components";
import Row from "../../Shared/Kit/Row";

export const Title = styled(Row)`
    font-size: ${(props) => props.theme.fontSizeMd2};
    font-weight: bold;
    margin-bottom: 30px;
    // text-shadow: 0px 3px 15px rgba(0, 0, 0, 0.5);
    ::before {
        content: "";
        width: 120px;
        height: 1px;
        background-color: ${(props) => props.theme.secondary};
        margin-left: 20px;
    }
    
    /* ::after {
        content: "";
        width: 1px;
        height: 25px;
        background-color: ${(props) => props.theme.secondary};
        margin-right: 25px;
    } */
`